<div fxLayout="column" fxLayoutGap="20px" *transloco="let t; read: 'PARKINGLOT'">

    <div fxLayoutAlign="center start">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>    
    <span>{{t('loading')}}</span> 

</div>
